import { render, staticRenderFns } from "./AllocateWorkers.vue?vue&type=template&id=100875ff&scoped=true&"
import script from "./AllocateWorkers.vue?vue&type=script&lang=js&"
export * from "./AllocateWorkers.vue?vue&type=script&lang=js&"
import style0 from "./AllocateWorkers.vue?vue&type=style&index=0&id=100875ff&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100875ff",
  null
  
)

export default component.exports